// extracted by mini-css-extract-plugin
module.exports = {"container":"Doctorworkstation_container__3jwi6","create":"Doctorworkstation_create__1qcAB"};